import classNames from "classnames";
import { ReactNode } from "react";
import HtmlHeading from "../titels/HtmlHeadings";

export type ColProps = {
    children: ReactNode;
    className?: string;
    width?: number;
    bold?: boolean;
    heading?: HtmlHeading;
};

export const MaxColWidth = 12;

const Col = ({ 
    children, 
    className, 
    width = 2, 
    bold = false, 
    heading 
} : ColProps ) => {

    const WrapperComponent = (heading ? `h${heading}` : "div") as keyof JSX.IntrinsicElements;

    return ( 
        <WrapperComponent className={classNames(`col-${width > MaxColWidth ? MaxColWidth : width}`, bold && "font-weight-bolder", className)}>
            {children}
        </WrapperComponent>
    )
}

export default Col;